import React from 'react';
import { Vector3 } from 'three';

import { Point2D, Point3D } from '@paragon/contract-library';
import { Segment3D } from '@paragon/three-shared';

import { poundToInchScalar } from '../../library/unitScalarsForVisuals';
import { reverseShiftSegment } from '../../library/utilities/reverseShiftSegment';
import { SegmentLabel } from '../util/SegmentLabel';
import { VectorVisual, VectorVisualType } from '../util/VectorVisual';
import { MomentVisual } from './MomentVisual';

export interface LinkEndResultVisualProps {
  readonly position: Point3D;
  readonly globalForceVector: Point2D;
  readonly axialForce: number;
  readonly moment: number;
}

export function LinkEndResultVisual({ position, globalForceVector, axialForce, moment }: LinkEndResultVisualProps) {
  const forceVector = new Vector3(globalForceVector.x * poundToInchScalar, globalForceVector.y * poundToInchScalar, 0);
  let forceSegment: Segment3D = { start: { x: 0, y: 0, z: 0 }, end: forceVector };
  let vectorVisualType;
  if (axialForce < 0) {
    vectorVisualType = VectorVisualType.Blue;
    forceSegment = reverseShiftSegment(forceSegment);
  } else {
    vectorVisualType = VectorVisualType.Yellow;
  }

  return (
    <object3D position={[position.x, position.y, position.z]}>
      <VectorVisual segment={forceSegment} thickness={0.2} vectorVisualType={vectorVisualType} />
      <SegmentLabel
        segment={forceSegment}
        text={`${globalForceVector.x.toFixed(0)},${globalForceVector.y.toFixed(0)}`}
      />
      <MomentVisual moment={moment} />
    </object3D>
  );
}
